(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/result/assets/javascripts/views/result.js') >= 0) return;  svs.modules.push('/modules/keno/components/result/assets/javascripts/views/result.js');

'use strict';

svs.keno.components.result.views.Result = Marionette.View.extend({
  viewOptions: ['dateString'],
  dateString: undefined,
  className: 'numbergames-content',
  regions: {
    resultRegion: '#resultContentRegion'
  },
  template(data) {
    return svs.keno.components.result.templates.result(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    this.showChildView('resultRegion', new svs.numbergames.results.views.GameResult({
      model: svs.numbergames.results.getResultModel({
        data: svs.keno.data.resultData,
        product: svs.numbergames.productMapping.CONSTANTS.KENO,
        selectedDate: this.dateString
      })
    }));
  }
});

 })(window);